import { STRINGS } from 'config';

const flags = STRINGS.FLAGS_REDUCER;

export const setIsClinicalReviewMode = isClinicalReviewMode => ({ type: flags.SET_IS_CLINICAL_REVIEW_MODE, payload: isClinicalReviewMode });

export const clearShowSessionExpiryValidationOnLoad = () => ({ type: flags.CLEAR_SHOW_SESSION_EXPIRY_VALIDATION_ON_LOAD });

export const setForceNhsLoginMode = forceNhsLoginMode => ({ type: flags.SET_FORCE_NHS_LOGIN_MODE, payload: forceNhsLoginMode });

export const setIsETriageBackHidden = isETriageBackHidden => ({ type: flags.SET_IS_ETRIAGE_BACK_HIDDEN, payload: isETriageBackHidden });
